/*
 * @authors :Bin Mei
 * @description：  患者管理模块路由
 */
// import UniqueRoute from './unique/route';


import { routersTypes } from 'src/pages/routes';
const route: routersTypes[] = [
  // {
  //   path: "/hospital/sugarblood",
  //   name: "Sugarblood",
  //   component: () => import(/* webpackPrefetchPlaceHolder */ './intro'),
  //   auth: false,
  //   exact: true,
  //   title: "专家解读糖尿病"
  // }, {
  //   path: "/hospital/sugarblood/one",
  //   name: "SugarbloodOne",
  //   component: () => import(/* webpackPrefetchPlaceHolder */ './intro/one'),
  //   auth: false,
  //   exact: true,
  //   title: "专家解读糖尿病"
  // }, {
  //   path: "/hospital/sugarblood/two",
  //   name: "SugarbloodTwo",
  //   component: () => import(/* webpackPrefetchPlaceHolder */ './intro/two'),
  //   auth: false,
  //   exact: true,
  //   title: "专家解读糖尿病"
  // }, {
  //   path: "/hospital/sugarbloodmanage",
  //   name: "SugarbloodManage",
  //   component: () => import(/* webpackPrefetchPlaceHolder */ './charts'),
  //   auth: true,
  //   exact: true,
  //   title: "血糖管理"
  // }, {
  //   path: "/hospital/sugarcharts",
  //   name: "SugarCharts",
  //   component: () => import(/* webpackPrefetchPlaceHolder */ './charts/sugarChart'),
  //   auth: true,
  //   exact: true,
  //   title: "血糖统计"
  // }, {
  //   path: "/hospital/sugarrecord",
  //   name: "SugarRecord",
  //   component: () => import(/* webpackPrefetchPlaceHolder */ './charts/sugarRecord'),
  //   auth: true,
  //   exact: true,
  //   title: "手动记录血糖值"
  // }, {
  //   path: "/hospital/sugarlist",
  //   name: "SugarList",
  //   component: () => import(/* webpackPrefetchPlaceHolder */ './charts/sugarList'),
  //   auth: true,
  //   exact: true,
  //   title: "血糖历史统计"
  // },
  {
    path: '/hospital/rights/detail',
    name: 'Rights',
    component: () => import(/* webpackPrefetchPlaceHolder */ './rights'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '权益详情',
  }, {
    path: '/hospital/rights/detail/special',
    name: 'RightsSpecial',
    component: () => import(/* webpackPrefetchPlaceHolder */ './rights'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '权益详情',
  }, {
    path: '/hospital/rights/invalidList',
    name: 'InvalidRights',
    component: () => import(/* webpackPrefetchPlaceHolder */ './rights/invalidList'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '失效权益',
  },
  // ...UniqueRoute
];
export default route;

